
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-text-card',
    imports: [MatIconModule, MatButtonModule, FormsModule],
    templateUrl: './text-card.component.html',
    styleUrl: './text-card.component.scss'
})
export class TextCardComponent {
  @Input() text: string = '';
  @Input() title: string = '';
  @Input() editable: boolean = false;
  @Input() onSaveAction!: (content: string) => Observable<any>;

  content!: string;

  ngOnInit() {
    this.content = this.text;
  }

  editMode: boolean = false;

  onEditClick(){
    this.editMode = !this.editMode;
  }

  onSave(): void {
    if (this.onSaveAction) {
      this.onSaveAction(this.content).subscribe({
        next: () => {
          this.editMode = false;
          this.text = this.content;
        }
      });
    }
  }

  onCancel(): void {
    this.editMode = false;
    this.content = this.text;
  }
}
